Vue.component('ppcarto-rome2rio', {

  template: `
  <div class="ppcarto-rome2rio" v-show="show">
    <header>
      <h2>plan your journey</h2>
    </header>
    <div class="search">
      <div class="row">
        <div class="group">
          <label>From</label>
          <ppcarto-typeahead ref="destination" :type="'origin'" :place="rome2rio.origin" :placeholder="'Start'" v-on:select="didSelect"></ppcarto-typeahead>
        </div>
        <div class="group">
          <label>To</label>
          <ppcarto-typeahead ref="destination" :type="'destination'" :place="rome2rio.destination" :placeholder="'Carinthia, Austria'" v-on:select="didSelect"></ppcarto-typeahead>
        </div>
      </div>
      <!--<div class="action">
        <a href="#"><img src="img/marker/rome2rio/switch.svg"></a>
      </div>-->
    </div>
    <div class="list-wrapper">
      <div class="route" v-for="(route, index) in routes" @mouseover="setActiveRoute(index)" v-bind:class="{ active: route.active }" @click="selected = index">
        <div class="info">
          <div class="name--segments">
            <h3>{{route.name}}</h3>
            <transition name="fade">
            <div v-bind:class="{ segments: true }" v-show="selected != index">
              <div class="segment" v-for="segment in route.segments" :class="rome2riodata.vehicles[segment.vehicle].kind"></div>
            </div>
            </transition>
          </div>
          <div class="price--duration">
            <span class="price">{{price(route)}}</span><br />
            <span class="duration">{{duration(route.totalDuration)}}</span>
          </div>
          <div class="indicator">
              <span>></span>
          </div>
        </div>
        <transition name="fade">
        <ul v-bind:class="{ routinginfo: true }"  v-show="selected == index">
          <li v-for="(segment, index) in route.segments" :class="rome2riodata.vehicles[segment.vehicle].kind">
            <div class="graph">
              <div class="line"></div>
              <div class="place"></div>
              <div class="kind"></div>
            </div>
            <div class="details">
              <div class="name">{{ index == 0 ? rome2riodata.places[route.depPlace].shortName : rome2riodata.places[segment.depPlace].shortName}}</div>
              <div class="info">
                <span class="duration">{{duration(segment.transitDuration)}}</span>
                <span class="prices">{{price(segment)}}</span>
                <span class="book">
                  <a class="book" v-if="segment.agencies && segment.agencies[0].links" v-bind:href="segment.agencies[0].links[0].url" target="_blank">{{segment.agencies[0].links[0].text}}</a>
                </span>
              </div>
            </div>
          </li>
          <li>
            <div class="graph">
              <div class="place"></div>
            </div>
            <div class="details">
              <div class="name">{{rome2riodata.places[route.arrPlace].shortName}}</div>
            </div>
          </li>
        </ul>
        </transition>
      </div>
    </div>
  </div>
  `,
  data () {
    return {
      from: "",
      to: "",
      origin: {},
      destination: {},
      selected: -1,
      translation: {
        "Book at": "Buchen",
        "Schedules at": "Fahrplan"
      }
    };
  },
  computed: {
    rome2rio(){
      return this.$store.getters.getRome2Rio;
    },
    rome2riodata(){
      return this.$store.getters.getRome2RioData;
    },
    routes(){
      if(this.$store.getters.getRome2RioData.routes) {
          return this.$store.getters.getRome2RioData.routes;
      } else {
        return [];
      }
    },
    show(){
      let history = this.$store.getters.getHistory;
      let last = _.last(history);
      if(last){
        return this.rome2rio.visible && last.key == "rome2rio" && !this.showMap;
      } else {
        return;
      }
    },
    showMap(){
      return this.$store.getters.showMap;
    }

  },

  watch: {
    rome2rio(options){
      this.from = options.from;
      this.to = options.to;
      this.origin = options.origin;
      this.destination = options.destination;
    }
  },

  methods: {
    setActiveRoute(index){
      let r2r = this.rome2riodata;
      _.each(r2r.routes, (r,i) => {r.active = (i == index)});
      this.$store.commit('setRome2RioData',r2r);
    },
    price(item) {
      let low = 0;
      let high = 0;
      if(item.indicativePrices) {
        if(item.indicativePrices.length > 1) {
          low = item.indicativePrices[item.indicativePrices.length - 1].price;
          high = item.indicativePrices[0].price;
        } else {
          low = item.indicativePrices[0].priceLow;
          high = item.indicativePrices[0].priceHigh;
        }

        if(low && high) {
            return `${low}€ - ${high}€`;
        } else {
          return `${item.indicativePrices[0].price}€`
        }


      } else {
        return "";
      }
    },
    duration(duration) {
      try {
        return moment.duration(duration,'minutes').format("h[Std] m[Min]");
      } catch (error) {
        console.log(duration);
        return "xxx";
      }

    },
    selectRoute(index) {
      let r2r = this.rome2riodata;
      _.each(r2r.routes, (r,i) => {r.selected = (i == index)});
      this.$store.commit('setRome2RioData',r2r);
    },
    submit() {
      this.$store.commit('setRome2Rio', {
        origin: this.origin || null,
        destination: (this.destination) ? this.destination : rome2rio.destination,
        from: this.origin.longName || null,
        to: this.destination.longName || null,
        visible: true
      })

    },
    didSelect(val){
      this[val.type] = val.place;
      if(this.origin && this.destination) {
        this.submit();
      }
    }
  }

});
